import { useResolvedAccessLevel } from '../../../components/PermissionsContainer';

/**
 * Component id gating the Dispatch Dashboard "Driver Board" tab, seeded at
 * access level 1 (View) for the dashboard read audience by migration 407.
 */
export const DRIVER_BOARD_COMPONENT_ID = 'dispatch-driver-board';

/** Tab id the Dispatch Dashboard registers the pinned tab under (Task 6). */
export const DRIVER_BOARD_TAB_ID = 'driver-board';

/**
 * Whether the current user may see the Driver Board tab at all.
 *
 * **Ships dark.** `defaultHidden = true` is the load-bearing argument: the
 * no-grant fallback in `useResolvedAccessLevel` is
 * `defaultHidden ? 0 : defaultDisabled ? 1 : 2`, so a user with no applicable
 * grant resolves to 0 → no tab. Passing `(id, false, true)` instead would
 * fall back to 1, and since the tab only needs View (>= 1) that would show
 * this brand-new grid to EVERYONE, which is the opposite of shipping dark.
 *
 * The gate is `>= 1` (not `>= 2`) because the board is read-only — there is no
 * Edit level to earn. Migration 407 seeds level 1 for the same groups that can
 * already read the dashboard; widen/narrow from the Permissions UI thereafter.
 *
 * `useResolvedAccessLevel` uses lenient context lookups, so in provider-less
 * test/preview trees this returns the fallback (false — hidden).
 */
export const useCanSeeDriverBoard = (): boolean =>
  useResolvedAccessLevel(DRIVER_BOARD_COMPONENT_ID, true) >= 1;
